import { EErrorPageTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить ошибку приложения
 */
export const setErrorPage = actionGenerator<EErrorPageTypes.Set, void>(EErrorPageTypes.Set);

/**
 * Сбросить ошибку приложения
 */
export const unsetErrorPage = actionGenerator<EErrorPageTypes.Unset, void>(EErrorPageTypes.Unset);
